






















































import Vue from "vue";
import Spinner from "@/components/Spinner.vue";
import { env } from "@/env";
import { ToastType, UseToast } from "@/components/root/toast/toast.state";
import * as api from "./api";
import { computed } from "@vue/composition-api";
export default Vue.extend({
  props: ["is_loading", "logo_url", "partner_id"],
  components: { Spinner },
  setup(props) {
    const login = async () => {
      const env_val = await env();
      const method =
        env_val.type === "Regular"
          ? api.getConsentUrl
          : api.getSingleUserConsentUrl;
      const res = await method();
      if (res.success) {
        console.log(res.value);
        window.open(res.value, "_self");
      } else {
        UseToast().show({
          type: ToastType.ALERT,
          msg:
            "Unfortunately there is some issue with our server, please try again later",
          duration: 5000,
        });
      }
    };

    const should_display_partner_logo = computed(
      () => props.partner_id && props.partner_id != "cognni"
    );

    const should_display_cognni_logo = computed(
      () => !props.partner_id || props.partner_id === "cognni"
    );
    return {
      login,
      should_display_cognni_logo,
      should_display_partner_logo,
    };
  },
});
